<template>
    <v-toolbar class="elevation-0" flat color="barrinfo">
        <v-toolbar-title :class="contextStyle.titleClass" color="barrtextinfo">
            <template v-if="contextStyle.sheet">
              <v-breadcrumbs large divider=">" :items="contextStyle.breadcrumbs" :class="'pl-0'">
                  <template v-slot:item="{ item }">
                      <v-breadcrumbs-item :href="item.href" :disabled="item.disabled">{{ item.text }}</v-breadcrumbs-item>
                  </template>
              </v-breadcrumbs>
            </template>
            <template v-else>
              <v-icon large :color="contextStyle.titleColor" :class="contextStyle.titleIcon">{{ contextStyle.icon }}</v-icon>
              <span>{{ (title) ? title : contextStyle.title }}</span>
            </template>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <slot name="right"/>
    </v-toolbar>
</template>

<script>
export default {
  props: {
    contextStyle: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      required: false
    }
  }
}
</script>
